<template>
    <b-row class="detail-row mt-2 mb-2" align-v="center">

        <b-col cols="7">
            {{ workingValue.fullObject.titulo_extendido }}
        </b-col>

        <b-col cols="2">
            <b-input-group prepend="Cant" size="sm">
                <b-form-input v-model="workingValue.cantidad" type="number" @change="$emit('input', workingValue)"/>
            </b-input-group>
        </b-col>

        <b-col cols="2">
            <b-input-group prepend="$" class="precio" size="sm">
                <b-form-input :value="(workingValue.cantidad * workingValue.fullObject.precio).toFixed(2)" readonly />
            </b-input-group>
        </b-col>

        <b-col cols="1" class="text-right">
            <b-button variant="outline-danger" block @click="triggerDelete()" size="sm">
                <i class="fa fa-trash"></i>
            </b-button>
        </b-col>

    </b-row>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'detail-row',

    props: {
        value: {
            type: Object
        }
    },
    
    data: () => {
        return {
            workingValue: {
                cantidad: 1,
                fullObject: {
                    titulo_extendido: '',
                    precio: 0
                }   
            }
        }
    },  

    methods: {
        triggerDelete() {
            this.$emit('delete', this.workingValue)
        }
    },

    beforeMount(){
        this.workingValue = _.cloneDeep(this.value)
    }
}

</script>

<style lang="less">
    .detail-row {
        // gap: 15px;
    }
</style>